<template>
  <ul class="map-schedule__graphic"
      v-if="odp && odp.hourlyLoad">
    <li class="map-schedule__graphic-item"
        :class="{
          'map-schedule__graphic-item_red': item.load === 4,
          'map-schedule__graphic-item_orange': item.load === 3,
          'map-schedule__graphic-item_yellow': item.load === 2,
          'map-schedule__graphic-item_green': item.load === 1,
        }"
        :key="i"
        v-for="(item, i) in this.hourLoad" >
      <span v-if="item.time.length === 4">0{{item.time}}</span>
      <span v-else>{{item.time}}</span>
    </li>
  </ul>
</template>

<script>

export default {
  name: 'ScheduleTimeWidget',
  props: {
    odp: Object,
    temporaryWorkBranch: Object,
  },
  computed: {
    hourLoad: function () {
      if (this.temporaryWorkBranch) {
        return this.odp.hourlyLoad.filter((item) => {
          return parseInt(item.time) >= parseInt(this.temporaryWorkBranch.start) && parseInt(item.time) < parseInt(this.temporaryWorkBranch.end);
        })
      }
      return this.odp.hourlyLoad;
    }
  },
}
</script>
